import React from 'react'
import { Breadcrumb } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { HomeOutlined } from '@ant-design/icons'

const breadcrumbNameMap: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/users': 'Users',
    '/merchants': 'Merchants',
    '/trials': 'Trial Management',
    '/rfqs': 'RFQs & Bids',
    '/orders': 'Orders',
    '/payments': 'Payments',
    '/settlements': 'Settlements',
    '/disputes': 'Disputes',
    '/notifications': 'Notifications',
    '/analytics': 'Analytics',
    '/roles': 'Roles & Permissions',
    '/settings': 'Settings',
    '/commissions': 'Commission Rules',
    '/marketplace-invoices': 'Marketplace Invoices',
    '/subscription-invoices': 'Subscription Invoices',
    '/profile': 'Profile',
}

export const BreadcrumbNav: React.FC = () => {
    const location = useLocation()
    const pathSnippets = location.pathname.split('/').filter((i) => i)

    const breadcrumbItems = [
        {
            title: (
                <Link to="/dashboard">
                    <HomeOutlined />
                </Link>
            ),
        },
        ...pathSnippets.map((_, index) => {
            const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
            const isLast = index === pathSnippets.length - 1

            return {
                title: isLast ? (
                    breadcrumbNameMap[url] || pathSnippets[index]
                ) : (
                    <Link to={url}>{breadcrumbNameMap[url] || pathSnippets[index]}</Link>
                ),
            }
        }),
    ]

    return (
        <Breadcrumb
            items={breadcrumbItems}
            style={{ marginBottom: 12 }}
        />
    )
}
